define((require) => {
    "use strict";

    const {defaults}          = require("underscore");
    const AbstractWidgetModel = require("shared/ui/experience/widgets/AbstractWidgetModel");
    const {isBlank}           = require("shared/util/StringUtils");

    const DEFAULT_TEXT = "";
    const DEFAULT_LINE_HEIGHT = 1.4;

    /**
     * Model for a text widget.
     *
     * @class TextWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("Text Enhanced widget", {

        transient: AbstractWidgetModel.prototype.transient.concat([
            "editorModel",
            "isSelected",
            "fontProvider",
            "fontProvider",
            "fontMetadata",
            "fontStyle",
            "color",
            "fontFamily",
            "textAlign",
            "fontWeight",
            "textDecoration",
            "textTransform",
            "fontVariant",
            "textShadow",
            "editorModel",
            "letterSpacing",
            "rawText"
        ]),

        defaults: defaults({
            type: "text-enhanced",
            text: DEFAULT_TEXT,
            lineHeight: DEFAULT_LINE_HEIGHT
        }, AbstractWidgetModel.prototype.defaults),

        constructor(attributes) {
            this.preserveProperties(attributes);
            this.__super();
            // Making sure these properties are set so we always have the same baseline.
            this.set("lineHeight", DEFAULT_LINE_HEIGHT, {silent: true});
        },

        hasText() {
            return this.get("text") && this.get("text") !== DEFAULT_TEXT;
        },

        isValid() {
            // We need the text string to make sense
            return !isBlank(this.get("text"));
        },

        getScaledSize(scaleX) {
            const size = AbstractWidgetModel.prototype.getScaledSize.call(this, scaleX);
            // We want to limit the minimum width to 1%
            size.width = Math.max(1, size.width);

            return size;
        },

        /**
         * Preserve the properties for the compatibility check in the view layer. If we don't do this, the raw response
         * data will be merged with default properties, which may end up corrupt data like font family(google font)
         * mismatching font provider(standard).
         *
         * @See {@link TextWidgetView.onRender calls font compatibility check}
         * @param {Object} attrs
         */
        preserveProperties(attrs) {
            if (attrs.fontFamily) {
                if (!attrs.fontProvider) {
                    attrs.fontProvider = null;
                }

                if (!attrs.fontMetadata) {
                    attrs.fontMetadata = {};
                }

                if (!attrs.fontFamilies) {
                    attrs.fontFamilies = [];
                }
            }

            if (!attrs.fontWeight) {
                attrs.fontWeight = null;
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/textEnhancedWidget/TextWidgetModel.js